/* Krautlegenden – Shirt-Roulette (sections/kl-shirt-roulette.liquid) */
import { CartUpdateEvent } from '@theme/events';

// Muss zu den automatischen Rabatten und zu snippets/kl-cart-progress.liquid passen.
const TIERS = [
  { qty: 2, pct: 10 },
  { qty: 3, pct: 15 },
  { qty: 4, pct: 20 }
];
// Produkte mit diesen Tags kommen nie in den Stapel (z. B. Shirts, die erst gestaltet werden müssen).
const EXCLUDE_TAGS = ['personalisierbar'];
const LEVELS = ['Frischling', 'Anwärter', 'Kumpel', 'Stammgast', 'Legende'];
const COLOR_HEX = { naturbeige: '#e7dcc3', 'weiß': '#ffffff', weiss: '#ffffff', schwarz: '#1b1b1b' };
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
const money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: CURRENCY });
const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ESC[c]);
const toCents = (p) => (p == null ? 0 : typeof p === 'string' ? Math.round(parseFloat(p) * 100) : Number(p) || 0);
const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
const isShirt = (t) => String(t || '').trim().toLowerCase() === 't-shirt';
const isExcluded = (p) => (p.tags || []).some((t) => EXCLUDE_TAGS.includes(String(t).trim().toLowerCase()));
const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const store = {
  get(k, fb) { try { const v = localStorage.getItem(k); return v == null ? fb : JSON.parse(v); } catch (e) { return fb; } },
  set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
};

function track(name, data) {
  try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
}

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function tierFor(count) {
  let t = null;
  TIERS.forEach((x) => { if (count >= x.qty) t = x; });
  return t;
}

const optIndex = (p, re) => (p.options || []).findIndex((o) => re.test(String(o.name || o)));
const COLOR_RE = /^(farbe|color|colour)$/i;
const SIZE_RE = /gr(ö|oe)(ß|ss)e|size/i;

function itemColor(item) {
  const o = (item.options_with_values || []).find((x) => COLOR_RE.test(x.name));
  return o ? String(o.value) : '';
}

class KlShirtRoulette extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.$ = (sel) => this.querySelector(sel);
    this.deckEl = this.$('[data-klr-deck]');
    this.stateEl = this.$('[data-klr-state]');
    this.gateEl = this.$('[data-klr-gate]');
    this.burstEl = this.$('[data-klr-burst]');
    this.toastEl = this.$('[data-klr-toast]');
    this.undoBtn = this.$('[data-klr-undo]');

    this.allHandle = this.dataset.all || 'shirts';
    this.filters = Array.from(this.querySelectorAll('[data-klr-filter]')).map((b) => b.dataset.klrFilter);
    const wanted = new URLSearchParams(location.search).get('kategorie');
    this.filter = wanted && this.filters.includes(wanted) ? wanted : this.allHandle;

    this.size = store.get('klr-size', null);
    this.seen = new Set(store.get('klr-seen', []));
    this.deck = [];
    this.history = [];
    this.pending = 0;
    this.count = 0;
    this.cartCombos = new Set();
    this.cache = new Map();
    this.firstCart = true;

    // Auf dieser Seite soll der Drawer nicht bei jedem Swipe aufgehen.
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) drawer.removeAttribute('auto-open');

    this.bind();
    this.syncChips();
    this.renderSize();
    this.showState('loading');

    this.syncCart().then(() => {
      if (!this.size) this.openGate(false);
      else this.rebuild();
    });
  }

  /* ---------------- Daten ---------------- */

  loadProducts(handle) {
    if (!this.cache.has(handle)) {
      this.cache.set(handle, fetch(ROOT + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250')
        .then((r) => (r.ok ? r.json() : { products: [] }))
        .then((d) => d.products || [])
        .catch(() => []));
    }
    return this.cache.get(handle);
  }

  buildCards(products) {
    const cards = [];
    const size = this.size;
    products.forEach((p) => {
      if (!isShirt(p.product_type) || isExcluded(p)) return;
      const ci = optIndex(p, COLOR_RE);
      const si = optIndex(p, SIZE_RE);
      const colors = ci >= 0 ? p.options[ci].values : [null];
      colors.forEach((color) => {
        const vs = (p.variants || []).filter((v) => ci < 0 || v['option' + (ci + 1)] === color);
        let img = '';
        if (colors.length === 1) {
          img = p.images && p.images[0] ? p.images[0].src : '';
        } else {
          // Nur mit eindeutigem Farbbild, sonst wüsste niemand, welche Farbe kommt.
          const withImg = vs.find((v) => v.featured_image && v.featured_image.src);
          img = withImg ? withImg.featured_image.src : '';
        }
        if (!img) return;
        const v = vs.find((x) => x.available && (si < 0 || x['option' + (si + 1)] === size));
        if (!v) return;
        const parts = String(p.title).split(/\s[–—-]\s/);
        cards.push({
          key: p.id + '|' + (color || ''),
          productId: p.id,
          handle: p.handle,
          title: parts[0],
          color: color || '',
          img,
          variantId: v.id,
          price: toCents(v.price),
          compare: toCents(v.compare_at_price),
          url: ROOT + 'products/' + p.handle + '?variant=' + v.id
        });
      });
    });
    return cards;
  }

  async rebuild() {
    this.history = [];
    this.updateUndo();
    this.showState('loading');
    const handle = this.filter;
    const products = await this.loadProducts(handle);
    if (handle !== this.filter) return;
    const cards = this.buildCards(products).filter((c) => !this.cartCombos.has(c.key));
    const fresh = shuffle(cards.filter((c) => !this.seen.has(c.key)));
    const seen = shuffle(cards.filter((c) => this.seen.has(c.key)));
    this.deck = fresh.concat(seen);
    if (!this.deck.length) {
      this.clearDeck();
      this.showState(products.length ? 'empty' : 'error');
      return;
    }
    this.showState(null);
    this.clearDeck();
    this.render(true);
  }

  async syncCart(cartIn) {
    try {
      const cart = cartIn || (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()));
      const items = cart.items || [];
      const count = items.filter((i) => isShirt(i.product_type)).reduce((s, i) => s + i.quantity, 0);
      this.cartCombos = new Set(items.map((i) => i.product_id + '|' + itemColor(i)));
      const before = this.count;
      this.count = count;
      this.renderLevel();
      if (!this.firstCart) {
        const t0 = tierFor(before);
        const t1 = tierFor(count);
        if (t1 && (!t0 || t1.qty > t0.qty)) this.celebrate(t1);
      }
      this.firstCart = false;
      this.refreshTopBadge();
      return cart;
    } catch (e) {
      return null;
    }
  }

  /* ---------------- Rendering ---------------- */

  clearDeck() {
    this.deckEl.querySelectorAll('.klr-card:not(.is-flying)').forEach((n) => n.remove());
  }

  cardEl(c) {
    const el = document.createElement('article');
    el.className = 'klr-card';
    el.dataset.key = c.key;
    const hex = COLOR_HEX[c.color.toLowerCase()] || '#ccc';
    const was = c.compare > c.price ? '<s>' + money.format(c.compare / 100) + '</s>' : '';
    el.innerHTML =
      '<img class="klr-card__img" src="' + esc(sized(c.img, 900)) + '" alt="' + esc(c.title + (c.color ? ' in ' + c.color : '')) + '" draggable="false" decoding="async">' +
      '<span class="klr-card__stamp klr-card__stamp--like" aria-hidden="true">Muss<br>haben</span>' +
      '<span class="klr-card__stamp klr-card__stamp--nope" aria-hidden="true">Nö</span>' +
      '<div class="klr-card__info">' +
        '<span class="klr-card__badge" data-klr-badge hidden></span>' +
        '<h2 class="klr-card__title">' + esc(c.title) + '</h2>' +
        '<p class="klr-card__meta">' +
          (c.color ? '<span class="klr-card__swatch" style="background:' + hex + '"></span>' + esc(c.color) + ' · ' : '') +
          'Größe ' + esc(this.size) +
        '</p>' +
        '<p class="klr-card__row">' +
          '<span class="klr-card__price">' + money.format(c.price / 100) + ' ' + was + '</span>' +
          '<a class="klr-card__link" href="' + esc(c.url) + '">Details</a>' +
        '</p>' +
      '</div>';
    return el;
  }

  render(intro) {
    const visible = this.deck.slice(0, 3);
    const existing = new Map();
    this.deckEl.querySelectorAll('.klr-card:not(.is-flying)').forEach((n) => existing.set(n.dataset.key, n));
    existing.forEach((n, k) => { if (!visible.some((c) => c.key === k)) n.remove(); });

    for (let i = visible.length - 1; i >= 0; i--) {
      const c = visible[i];
      let el = existing.get(c.key);
      if (!el) el = this.cardEl(c);
      el.dataset.pos = String(i);
      el.style.transform = '';
      el.style.transition = '';
      el.classList.remove('is-top', 'is-hint');
      if (i === 0) el.classList.add('is-top');
      this.deckEl.appendChild(el);
    }
    // nächste Bilder vorladen
    this.deck.slice(3, 5).forEach((c) => { const i = new Image(); i.src = sized(c.img, 900); });

    const top = this.deckEl.querySelector('.klr-card.is-top');
    if (top) this.attachDrag(top);
    this.refreshTopBadge();

    if (intro && top && !store.get('klr-hinted', false) && !reduceMotion) top.classList.add('is-hint');
    if (!this.deck.length) this.showState('end');
  }

  refreshTopBadge() {
    const badge = this.deckEl && this.deckEl.querySelector('.klr-card.is-top [data-klr-badge]');
    if (!badge) return;
    const next = TIERS.find((t) => t.qty === this.count + 1);
    if (next) {
      badge.textContent = next.qty === 4 ? 'Macht dich zur Legende: −20 %' : 'Schaltet −' + next.pct + ' % frei';
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  renderLevel() {
    const c = this.count;
    const lvl = LEVELS[Math.min(c, LEVELS.length - 1)];
    let msg;
    if (c === 0) msg = 'Swipe 2 Shirts rein – dann gibt’s −10 % auf alle.';
    else if (c === 1) msg = 'Noch 1 Shirt bis −10 %.';
    else if (c === 2) msg = '−10 % gesichert. Noch 1 bis −15 %.';
    else if (c === 3) msg = '−15 % gesichert. Noch 1 bis zum Legenden-Rabatt.';
    else msg = 'Legenden-Status: −20 % auf alle Shirts.';
    this.$('[data-klr-level]').textContent = lvl;
    this.$('[data-klr-msg]').textContent = msg;
    this.toggleAttribute('data-legend', c >= 4);
    this.querySelectorAll('.klr__slot').forEach((s, i) => s.classList.toggle('is-filled', i < c));
  }

  renderSize() {
    this.$('[data-klr-size]').textContent = this.size || '–';
    this.querySelectorAll('[data-klr-size-pick]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.klrSizePick === this.size)));
  }

  syncChips() {
    this.querySelectorAll('[data-klr-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.klrFilter === this.filter)));
  }

  showState(kind) {
    const el = this.stateEl;
    if (!kind) { el.hidden = true; el.innerHTML = ''; return; }
    let html = '';
    if (kind === 'loading') {
      html = '<span class="klr__spinner" aria-hidden="true"></span><p class="klr__panel-title">Mische die Shirts …</p>';
    } else if (kind === 'empty') {
      html = '<p class="klr__panel-kicker">Hm.</p><p class="klr__panel-title">In Größe ' + esc(this.size) + ' ist hier gerade nichts Neues dabei.</p>' +
        '<div class="klr__panel-actions"><button type="button" class="klr__cta" data-klr-size-open>Größe ändern</button>' +
        (this.filter !== this.allHandle ? '<button type="button" class="klr__cta klr__cta--ghost" data-klr-filter-go="' + esc(this.allHandle) + '">Alle Shirts</button>' : '') + '</div>';
    } else if (kind === 'error') {
      html = '<p class="klr__panel-title">Die Shirts konnten nicht geladen werden.</p><div class="klr__panel-actions"><button type="button" class="klr__cta" data-klr-reshuffle>Nochmal versuchen</button></div>';
    } else if (kind === 'end') {
      html = '<p class="klr__panel-kicker">Das war’s</p><p class="klr__panel-title">Du hast alles gesehen, ' + (this.count >= 4 ? 'Legende' : 'Respekt') + '.</p>' +
        '<p class="klr__panel-note">' + (this.count ? this.count + (this.count === 1 ? ' Shirt' : ' Shirts') + ' im Warenkorb.' : 'Noch nix dabei gewesen? Probier eine andere Kategorie.') + '</p>' +
        '<div class="klr__panel-actions">' +
        (this.count ? '<button type="button" class="klr__cta" data-klr-cart>Zum Warenkorb</button>' : '') +
        '<button type="button" class="klr__cta klr__cta--ghost" data-klr-reshuffle-all>Nochmal mischen</button></div>';
    }
    el.innerHTML = html;
    el.hidden = false;
  }

  /* ---------------- Swipen ---------------- */

  attachDrag(el) {
    if (el._drag) return;
    el._drag = true;
    let sx = 0, sy = 0, dx = 0, dy = 0, t0 = 0, active = false, pid = null;

    const move = (e) => {
      if (!active || e.pointerId !== pid) return;
      dx = e.clientX - sx;
      dy = e.clientY - sy;
      el.style.transform = 'translate(' + dx + 'px,' + dy * 0.25 + 'px) rotate(' + dx / 16 + 'deg)';
      const p = Math.max(-1, Math.min(1, dx / 110));
      el.style.setProperty('--like', Math.max(0, p));
      el.style.setProperty('--nope', Math.max(0, -p));
      this.deckEl.style.setProperty('--p', Math.min(1, Math.abs(dx) / 140));
    };
    const end = (e) => {
      if (!active || (e && e.pointerId !== pid)) return;
      active = false;
      el.classList.remove('is-dragging');
      const v = Math.abs(dx) / Math.max(1, performance.now() - t0);
      this.deckEl.style.removeProperty('--p');
      if (Math.abs(dx) > 110 || (Math.abs(dx) > 45 && v > 0.6)) {
        this.commit(dx > 0 ? 'right' : 'left', dx, dy);
      } else {
        el.style.transition = 'transform .28s cubic-bezier(.2,.9,.3,1.3)';
        el.style.transform = '';
        el.style.setProperty('--like', 0);
        el.style.setProperty('--nope', 0);
      }
      if (Math.abs(dx) > 6) el._moved = true;
    };

    el.addEventListener('pointerdown', (e) => {
      if (!el.classList.contains('is-top') || e.button > 0) return;
      if (e.target.closest('a')) return;
      active = true; pid = e.pointerId;
      sx = e.clientX; sy = e.clientY; dx = 0; dy = 0; t0 = performance.now();
      el._moved = false;
      el.classList.remove('is-hint');
      el.classList.add('is-dragging');
      el.style.transition = 'none';
      try { el.setPointerCapture(pid); } catch (err) {}
    });
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('click', (e) => { if (el._moved && e.target.closest('a')) e.preventDefault(); });
  }

  commit(dir, dx = 0, dy = 0) {
    if (!this.deck.length || !this.gateEl.hidden) return;
    if (!this.burstEl.hidden && this.burstEl.dataset.sticky) return;
    const card = this.deck.shift();
    const el = this.deckEl.querySelector('.klr-card.is-top');
    store.set('klr-hinted', true);

    if (el) {
      el.classList.remove('is-top', 'is-hint');
      el.classList.add('is-flying');
      const tx = (dir === 'right' ? 1 : -1) * (window.innerWidth + 200);
      el.style.setProperty(dir === 'right' ? '--like' : '--nope', 1);
      el.style.transition = reduceMotion ? 'opacity .2s' : 'transform .38s cubic-bezier(.3,.6,.4,1), opacity .38s';
      el.style.transform = 'translate(' + tx + 'px,' + (dy * 0.25 + 40) + 'px) rotate(' + (dir === 'right' ? 28 : -28) + 'deg)';
      el.style.opacity = '0';
      setTimeout(() => el.remove(), 420);
    }

    this.seen.add(card.key);
    store.set('klr-seen', Array.from(this.seen).slice(-600));

    const entry = { card, dir, lineKey: null };
    this.history.push(entry);
    if (this.history.length > 15) this.history.shift();

    track('kl_roulette_swipe', {
      direction: dir === 'right' ? 'add' : 'skip',
      product_id: String(card.productId),
      variant_id: String(card.variantId),
      handle: card.handle,
      color: card.color,
      size: this.size,
      collection: this.filter
    });

    if (dir === 'right') this.add(entry);
    this.render(false);
    this.updateUndo();
  }

  sectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((n) => n.dataset.sectionId).filter(Boolean);
  }

  async add(entry) {
    this.pending++;
    this.updateUndo();
    const ids = this.sectionIds();
    try {
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: entry.card.variantId, quantity: 1 }], sections: ids.join(','), sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'add failed');
      const item = (data.items && data.items[0]) || data;
      entry.lineKey = item.key;
      const cart = await this.syncCart();
      if (cart) {
        document.dispatchEvent(new CartUpdateEvent(cart, 'kl-shirt-roulette', {
          source: 'kl-shirt-roulette', itemCount: cart.item_count, variantId: String(entry.card.variantId), sections: data.sections
        }));
      }
      this.toast('„' + entry.card.title.replace(/^[„"“]|[“"”]$/g, '') + '“ ist im Warenkorb.', true);
    } catch (err) {
      console.error('[kl-shirt-roulette]', err);
      const i = this.history.indexOf(entry);
      if (i > -1) this.history.splice(i, 1);
      this.seen.delete(entry.card.key);
      this.deck.unshift(entry.card);
      this.showState(null);
      this.render(false);
      this.toast('Das hat nicht geklappt – versuch’s nochmal.', false);
    } finally {
      this.pending--;
      this.updateUndo();
    }
  }

  async undo() {
    if (this.pending || !this.history.length) return;
    const entry = this.history.pop();
    this.updateUndo();
    if (entry.dir === 'right' && entry.lineKey) {
      this.pending++;
      try {
        const cart0 = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const line = (cart0.items || []).find((i) => i.key === entry.lineKey);
        if (line) {
          const ids = this.sectionIds();
          const res = await fetch(ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: entry.lineKey, quantity: line.quantity - 1, sections: ids.join(','), sections_url: location.pathname })
          });
          const cart = await res.json();
          this.firstCart = true; // beim Zurücknehmen nicht feiern
          await this.syncCart(cart);
          document.dispatchEvent(new CartUpdateEvent(cart, 'kl-shirt-roulette', {
            source: 'kl-shirt-roulette', itemCount: cart.item_count, sections: cart.sections
          }));
        }
      } catch (e) {
        console.error('[kl-shirt-roulette]', e);
      } finally {
        this.pending--;
      }
    }
    this.seen.delete(entry.card.key);
    store.set('klr-seen', Array.from(this.seen).slice(-600));
    this.deck.unshift(entry.card);
    this.showState(null);
    this.render(false);
    const top = this.deckEl.querySelector('.klr-card.is-top');
    if (top && !reduceMotion) {
      const from = entry.dir === 'right' ? 1 : -1;
      top.style.transition = 'none';
      top.style.transform = 'translateX(' + from * 120 + '%) rotate(' + from * 20 + 'deg)';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        top.style.transition = 'transform .35s cubic-bezier(.2,.9,.3,1.15)';
        top.style.transform = '';
      }));
    }
    this.hideToast();
    this.updateUndo();
    track('kl_roulette_undo', { product_id: String(entry.card.productId), was: entry.dir === 'right' ? 'add' : 'skip' });
  }

  updateUndo() {
    this.undoBtn.disabled = !this.history.length || this.pending > 0;
  }

  /* ---------------- Gamification ---------------- */

  celebrate(tier) {
    const legend = tier.qty >= 4;
    let confetti = '';
    for (let i = 0; i < 26; i++) {
      const left = Math.round(Math.random() * 100);
      const delay = (Math.random() * 0.35).toFixed(2);
      const dur = (1 + Math.random() * 0.9).toFixed(2);
      const rot = Math.round(Math.random() * 360);
      const col = ['#e0930d', '#4f6f3a', '#d8c7a3', '#171717', '#f2c14e'][i % 5];
      confetti += '<i style="left:' + left + '%;background:' + col + ';animation-delay:' + delay + 's;animation-duration:' + dur + 's;transform:rotate(' + rot + 'deg)"></i>';
    }
    this.burstEl.innerHTML =
      '<div class="klr__confetti" aria-hidden="true">' + (reduceMotion ? '' : confetti) + '</div>' +
      '<p class="klr__burst-kicker">' + (legend ? 'Level freigeschaltet' : 'Rabatt freigeschaltet') + '</p>' +
      '<p class="klr__burst-pct">−' + tier.pct + '&nbsp;%</p>' +
      '<p class="klr__burst-level">' + (legend ? 'Du bist jetzt offiziell eine <strong>Legende</strong>.' : 'auf alle Shirts im Warenkorb') + '</p>' +
      (legend
        ? '<div class="klr__panel-actions"><button type="button" class="klr__cta" data-klr-cart>Zum Warenkorb</button><button type="button" class="klr__cta klr__cta--ghost" data-klr-burst-close>Weiter swipen</button></div>'
        : '');
    this.burstEl.hidden = false;
    this.burstEl.classList.remove('is-out');
    if (legend) this.burstEl.dataset.sticky = '1';
    else delete this.burstEl.dataset.sticky;
    try { if (navigator.vibrate) navigator.vibrate(legend ? [30, 60, 30] : 30); } catch (e) {}
    track('kl_roulette_tier', { tier_pct: tier.pct, shirts: this.count });
    clearTimeout(this._burstT);
    if (!legend) this._burstT = setTimeout(() => this.closeBurst(), 1700);
  }

  closeBurst() {
    clearTimeout(this._burstT);
    this.burstEl.classList.add('is-out');
    delete this.burstEl.dataset.sticky;
    setTimeout(() => { this.burstEl.hidden = true; this.burstEl.classList.remove('is-out'); }, 250);
  }

  /* ---------------- UI ---------------- */

  toast(text, withUndo) {
    clearTimeout(this._toastT);
    this.toastEl.innerHTML = '<span>' + esc(text) + '</span>' + (withUndo ? '<button type="button" data-klr-undo-toast>Rückgängig</button>' : '');
    this.toastEl.hidden = false;
    requestAnimationFrame(() => this.toastEl.classList.add('is-in'));
    this._toastT = setTimeout(() => this.hideToast(), 3500);
  }

  hideToast() {
    clearTimeout(this._toastT);
    this.toastEl.classList.remove('is-in');
    setTimeout(() => { if (!this.toastEl.classList.contains('is-in')) this.toastEl.hidden = true; }, 300);
  }

  openGate(cancellable) {
    this.gateEl.hidden = false;
    this.$('[data-klr-gate-close]').hidden = !cancellable;
    this.renderSize();
  }

  openCart() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else location.href = ROOT + 'cart';
  }

  setFilter(handle) {
    if (!this.filters.includes(handle)) return;
    this.filter = handle;
    this.syncChips();
    try {
      const u = new URL(location.href);
      if (handle === this.allHandle) u.searchParams.delete('kategorie'); else u.searchParams.set('kategorie', handle);
      history.replaceState(history.state, '', u);
    } catch (e) {}
    track('kl_roulette_filter', { collection: handle });
    if (this.size) this.rebuild();
  }

  bind() {
    this.addEventListener('click', (e) => {
      const t = e.target.closest('button');
      if (!t || !this.contains(t)) return;
      if (t.matches('[data-klr-filter]')) this.setFilter(t.dataset.klrFilter);
      else if (t.matches('[data-klr-filter-go]')) this.setFilter(t.dataset.klrFilterGo);
      else if (t.matches('[data-klr-nope]')) this.commit('left');
      else if (t.matches('[data-klr-like]')) this.commit('right');
      else if (t.matches('[data-klr-undo], [data-klr-undo-toast]')) this.undo();
      else if (t.matches('[data-klr-size-open]')) this.openGate(true);
      else if (t.matches('[data-klr-gate-close]')) this.gateEl.hidden = true;
      else if (t.matches('[data-klr-size-pick]')) {
        const changed = t.dataset.klrSizePick !== this.size;
        this.size = t.dataset.klrSizePick;
        store.set('klr-size', this.size);
        this.renderSize();
        this.gateEl.hidden = true;
        track('kl_roulette_size', { size: this.size });
        if (changed || !this.deck.length) this.rebuild();
      } else if (t.matches('[data-klr-cart]')) { this.closeBurst(); this.openCart(); }
      else if (t.matches('[data-klr-burst-close]')) this.closeBurst();
      else if (t.matches('[data-klr-reshuffle]')) { this.cache.delete(this.filter); this.rebuild(); }
      else if (t.matches('[data-klr-reshuffle-all]')) this.rebuild();
    });

    document.addEventListener('keydown', (e) => {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.altKey) return;
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT/.test(tag) || document.querySelector('dialog[open]')) return;
      if (!this.gateEl.hidden) return;
      const r = this.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.commit('left'); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.commit('right'); }
      else if (e.key === 'Backspace') { e.preventDefault(); this.undo(); }
    });

    // Warenkorb wurde woanders geändert (Drawer, Cross-Sell) -> Level aktualisieren
    document.addEventListener('cart:update', (e) => {
      const src = e.detail && e.detail.data && e.detail.data.source;
      if (src === 'kl-shirt-roulette') return;
      clearTimeout(this._syncT);
      this._syncT = setTimeout(() => this.syncCart(), 300);
    });
  }
}

if (!customElements.get('kl-shirt-roulette')) customElements.define('kl-shirt-roulette', KlShirtRoulette);
